import { ContentWithEyeColumn } from 'components/TableColumn/ContentWithEyeColumn';
import { NameWithIdColumn } from 'components/TableColumn/NameWithIdColumn';
import { ECSegmentListDTO, ECSegmentType, FINAL_STATUS } from 'core/ecSegment/ECSegment';
import { get, omit } from 'lodash';
import { useCallback, useContext, useMemo, useRef, useState } from 'react';
import styles from './ecSegmentNameIdColumn.module.scss';
import i18n from 'i18n';
import { ECSegmentRulesModal } from './ECSegmentRulesModal';
import { Overlay } from 'react-bootstrap';
import refContext from 'contexts/refContext';

export const ECSegmentNameIdColumn: React.FC<{
  ecSegment: ECSegmentListDTO
}> = ({
  ecSegment
}) => {

  const [showRules, setShowRules] = useState<boolean>(false);

  const canEdit = !FINAL_STATUS.includes(ecSegment.status);
  const clickUrl =
    get(ecSegment, 'type') !== ECSegmentType.INTERSECT && canEdit
      ? `/ec-segments/${ecSegment.id}/edit`
      : undefined;

  const target = useRef<HTMLDivElement>(null);
  const showRulesModal = useCallback(() => {
    setShowRules(true);
  }, []);

  const hideRulesModal = useCallback(() => {
    setShowRules(false);
  }, []);

  const refContextValue = useContext(refContext);

  const tooltipProps = useMemo(() => ({
    id: `faEye-tooltip-${ecSegment.id}`,
    tooltip: i18n.t<string>('ecSegmentList.buttons.showDetails')
  }), [ecSegment]);

  return (
    <div className={styles.ecSegmentNameIdColumn} ref={target}>
      <ContentWithEyeColumn
        value={ecSegment.id}
        className={styles.eyeColumnContainer}
        iconClassName={styles.eyeClassName}
        onClickBtn={showRulesModal}
        tooltipProps={tooltipProps}
        contentData={{
          component: NameWithIdColumn,
          props: {
            id: ecSegment.id,
            name: ecSegment.name,
            clickUrl: clickUrl,
            className: styles.nameWithIdColumn,
            showId: true
          }
        }}
      />
      <Overlay
        target={target}
        container={refContextValue?.ref}
        show={showRules}
        placement='right-start'
      >
        {(props) => (
          <div
            {...omit(props, ['placement', 'arrowProps', 'show', 'popper'])}
            style={{ ...props.style, zIndex: 100 }}
          >
            <ECSegmentRulesModal
              ecSegmentId={ecSegment.id}
              advertiserId={ecSegment.advertiserId}
              onClose={hideRulesModal}
            />
          </div>
        )}
      </Overlay>
    </div>
  );
};

export const renderECSegmentNameIdColumn = (
  ecSegment: ECSegmentListDTO
) => {
  return (
    <ECSegmentNameIdColumn
      ecSegment={ecSegment}
    />
  );
};
